import { FC, Fragment, useContext } from "react";
import { UserProgramContext } from "../../context/user-program/user-program";
import { Navigate } from "react-router-dom";
import { ROUTE_HOME, SUBROUTE_SIGN_IN } from "../../constants";

type Props = {
  children: React.ReactNode;
};

const SIGN_IN_ROUTE = `${ROUTE_HOME}${SUBROUTE_SIGN_IN}`;

export const ClinicProtectedRoute: FC<Props> = ({ children }) => {
  const { unauthorized, role } = useContext(UserProgramContext);

  if (unauthorized || (role !== "clinic-dashboard" && role !== "admin")) {
    return <Navigate to={SIGN_IN_ROUTE} replace={true} />;
  }

  return <Fragment>{children}</Fragment>;
};
